import { useEffect } from "react"

import {
  useHeaderActions,
  type HeaderAction,
} from "@/contexts/HeaderActionsContext"

/**
 * Hook to set header actions in the SidebarNav.
 * Actions are automatically cleared when the component unmounts.
 */
export const useSetHeaderActions = (action: HeaderAction | null) => {
  const { setHeaderActions } = useHeaderActions()

  useEffect(() => {
    setHeaderActions(action)

    // Clear actions on unmount
    return () => {
      setHeaderActions(null)
    }
  }, [action, setHeaderActions])
}
